// Base on Device.js by Matthew Hudson
// Device.js is freely distributable under the MIT license.
// For all details and documentation:
// http://matthewhudson.me/projects/device.js/

export default (() => {
  const device = {
    ios: (): boolean => false,
    iphone: (): boolean => false,
    ipod: (): boolean => false,
    ipad: (): boolean => false,
    android: (): boolean => false,
    androidPhone: (): boolean => false,
    androidTablet: (): boolean => false,
    blackberry: (): boolean => false,
    blackberryPhone: (): boolean => false,
    blackberryTablet: (): boolean => false,
    windows: (): boolean => false,
    windowsPhone: (): boolean => false,
    windowsTablet: (): boolean => false,
    fxos: (): boolean => false,
    fxosPhone: (): boolean => false,
    fxosTablet: (): boolean => false,
    meego: (): boolean => false,
    nodeWebkit: (): boolean => false,
    mobile: (): boolean => false,
    tablet: (): boolean => false,
    desktop: (): boolean => false,
    windowsDevices: (): boolean => false,
  };

  // The client user agent string.
  // Lowercase, so we can use the more efficient indexOf(), instead of Regex
  const userAgent = window.navigator.userAgent.toLowerCase();

  const find = (text: string): boolean => {
    return userAgent.indexOf(text) !== -1;
  };

  // Main functions
  // --------------

  device.ios = () => {
    return device.iphone() || device.ipod() || device.ipad();
  };

  device.iphone = () => {
    return !device.windows() && find('iphone');
  };

  device.ipod = () => {
    return find('ipod');
  };

  device.ipad = () => {
    return find('ipad');
  };

  device.android = () => {
    return !device.windows() && find('android');
  };

  device.androidPhone = () => {
    return device.android() && find('mobile');
  };

  device.androidTablet = () => {
    return device.android() && !find('mobile');
  };

  device.blackberry = () => {
    return find('blackberry') || find('bb10') || find('rim');
  };

  device.blackberryPhone = () => {
    return device.blackberry() && !find('tablet');
  };

  device.blackberryTablet = () => {
    return device.blackberry() && find('tablet');
  };

  device.windows = () => {
    return find('windows');
  };

  device.windowsPhone = () => {
    return device.windows() && find('phone');
  };

  device.windowsTablet = () => {
    return device.windows() && find('touch') && !device.windowsPhone();
  };

  device.fxos = () => {
    return (find('(mobile;') || find('(tablet;')) && find('; rv:');
  };

  device.fxosPhone = () => {
    return device.fxos() && find('mobile');
  };

  device.fxosTablet = () => {
    return device.fxos() && find('tablet');
  };

  device.meego = () => {
    return find('meego');
  };

  device.nodeWebkit = () => {
    return typeof (window as Window & { process?: unknown }).process === 'object';
  };

  device.mobile = () => {
    return (
      device.androidPhone() ||
      device.iphone() ||
      device.ipod() ||
      device.windowsPhone() ||
      device.blackberryPhone() ||
      device.fxosPhone() ||
      device.meego()
    );
  };

  device.tablet = () => {
    return (
      device.ipad() ||
      device.androidTablet() ||
      device.blackberryTablet() ||
      device.windowsTablet() ||
      device.fxosTablet()
    );
  };

  device.desktop = () => {
    return !device.tablet() && !device.mobile();
  };

  device.windowsDevices = () => {
    return device.windows() || device.windowsPhone() || device.windowsTablet();
  };

  return device;
})();
